import { CALCULADORAS } from '@/lib/calculadoras/lista'

/** Bloco financeiro — controle do dia a dia do MEI. */
export const FINANCEIRO_NAV = [
  { href: '/dashboard', label: 'Painel' },
  { href: '/dashboard/planejamento', label: 'Orçamento' },
  { href: '/registrar', label: 'Registrar faturamento' },
] as const

/** Cada calculadora é uma rota em /calculadoras/[slug]. DAS fica no mesmo grupo. */
export const CALCULADORA_LINKS = [
  ...CALCULADORAS.map((c) => ({ href: c.href, label: c.titulo })),
  { href: '/calculadoras/das', label: 'DAS' },
] as const

export const HISTORICO_CALCULOS = {
  href: '/dashboard/historico',
  label: 'Meus cálculos salvos',
} as const

/** Ferramentas/documentos do MEI — geram saídas a partir dos números.
 *  Labels curtos pra caber na sidebar sem truncar. */
export const FERRAMENTAS_NAV = [
  { href: '/comprovante-de-faturamento-mei', label: 'Comprovante' },
  { href: '/quanto-posso-me-pagar-mei', label: 'Quanto retirar' },
  { href: '/dre-simplificado-mei', label: 'DRE simplificado' },
] as const

/** Conteúdo e referência — fora do núcleo financeiro. */
export const RECURSOS_NAV = [
  { href: '/atividades-mei', label: 'Profissões MEI' },
  { href: '/templates', label: 'Templates' },
  { href: '/glossario', label: 'Glossário' },
  { href: '/blog', label: 'Blog' },
] as const

/** Rotas que pertencem ao grupo Calculadoras na sidebar. */
export function isCalculadorasSection(pathname: string) {
  if (pathname === '/dashboard/historico' || pathname.startsWith('/dashboard/historico/')) {
    return true
  }
  if (pathname === '/calculadoras' || pathname.startsWith('/calculadoras/')) {
    return true
  }
  return false
}

export function isSidebarLinkActive(pathname: string, href: string) {
  if (href === '/dashboard') {
    return pathname === '/dashboard'
  }
  if (href === '/calculadoras') {
    return pathname === '/calculadoras'
  }
  if (href === '/dashboard/planejamento') {
    return pathname === '/dashboard/planejamento' || pathname.startsWith('/dashboard/planejamento/')
  }

  return pathname === href || pathname.startsWith(href + '/')
}
